import { FunctionComponent } from "react";

import { Stack } from "@bps/fluent-ui";
import { SectionTitle } from "@components/SectionTitle";
import { withPermissions } from "@components/withPermissions";
import { Permissions } from "@libs/permissions/permissions.enum";

import { InsightsParser } from "./components/InsightsParser";
import { KqlBuilder } from "./components/KqlBuilder";

export const B2CLogsBase: FunctionComponent = () => {
  return (
    <Stack tokens={{ childrenGap: 16 }} styles={{ root: { height: "100%" } }}>
      <SectionTitle>B2C AppInsights Log Summary</SectionTitle>
      <KqlBuilder />
      <InsightsParser />
    </Stack>
  );
};

export const B2CLogs = withPermissions(
  B2CLogsBase,
  Permissions.PltCatalogUserRead
);
